"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBEmailNotification;
var _react = _interopRequireDefault(require("react"));
var _SVBButton = require("../../SVBButton");
var _SVBTypography = require("../../SVBTypography");
var _Notification = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Notification.svg"));
var _Error = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Error.svg"));
var _exclamationCircle = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/exclamation-circle.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * SVBEmailNotification
 * @param type: define color
 * @param title: define title
 * @param message: define message
 * @param buttonText: define button title
 * @param onClick: execute something with the onClick event
 * @returns alert with content
 */
function SVBEmailNotification(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.type === 'error' ? 'emailNotification-error' : 'emailNotification-info'
  }, (props === null || props === void 0 ? void 0 : props.type) === 'error' && /*#__PURE__*/_react.default.createElement("div", {
    className: "emailNotification__icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "info",
    src: _Error.default
  })), ((props === null || props === void 0 ? void 0 : props.type) === 'info' || !(props !== null && props !== void 0 && props.type)) && /*#__PURE__*/_react.default.createElement("div", {
    className: "emailNotification__icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "info",
    src: _Notification.default
  })), (props === null || props === void 0 ? void 0 : props.type) === 'advert' && /*#__PURE__*/_react.default.createElement("div", {
    className: "emailNotification__icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "info",
    src: _exclamationCircle.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "emailNotification__copy-container"
  }, /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    type: "sub-heading"
  }, props === null || props === void 0 ? void 0 : props.title), /*#__PURE__*/_react.default.createElement(_SVBTypography.SVBTypography, {
    type: "paragraph",
    variant: "small"
  }, props === null || props === void 0 ? void 0 : props.message)), (props === null || props === void 0 ? void 0 : props.onClick) && /*#__PURE__*/_react.default.createElement("div", {
    className: "emailNotification__button-container"
  }, /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    extraClasses: "m-1",
    text: props.buttonText,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    onClick: props === null || props === void 0 ? void 0 : props.onClick
  })));
}